import React, { useEffect } from 'react'

function loadScript (portalId) {
  if (window.isHubspotScriptLoaded) {
    return
  }
  window.isHubspotScriptLoaded = true
  const script = document.createElement('script')
  script.setAttribute('data-ccm-loader-src', 'https://js.hs-scripts.com/' + portalId + '.js')
  script.setAttribute('type', 'text/x-ccm-loader')
  script.setAttribute('data-ccm-loader-group', 'data-ccm-loader-group-hubspot')
  // script.id = 'hs-script-loader'
  script.async = true
  script.defer = true
  document.body.appendChild(script)
}

const useHubspot = (portalId) => {
  const sendPageView = React.useCallback((locationPathname) => {
    let _hsq = (window._hsq = window._hsq || [])
    _hsq.push(['setPath', locationPathname]) // window.location.pathname
    _hsq.push(['trackPageView'])
    // console.log('set new path for hubspot: ', locationPathname)
  }, [])

  useEffect(() => {
    loadScript(portalId)
  }, [portalId, sendPageView])

  return {
    sendPageView
  }
}

export default useHubspot
